import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createRef, useEffect, useState } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { Loading } from '@ibk/shared-ui';
import useTimer from '../../hooks/useTimer';
import { clearBelvoExternalId, withBelvoExternalId } from '../../services/belvoExternalId';
import { usePrefillMutation } from '../../services/openFinanceApi';
import { OpenFinanceFeedbackEnum } from '../../services/types';
import styles from './ConsentFeedback.module.css';
const redirectToDashboard = () => {
    window.parent.location.replace('/contabilidade-digital');
};
const FeedbackContent = ({ params, belvoUri, widgetRef, setLoading, loading, }) => {
    const { t } = useTranslation();
    if (params.event === OpenFinanceFeedbackEnum.APPLICATION_LINK && belvoUri) {
        return (_jsx("iframe", { className: styles.iframe, sandbox: 'allow-scripts allow-top-navigation allow-same-origin allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox', ref: widgetRef, onLoad: () => setLoading(false), id: 'belvoWidget', title: 'Belvo', width: '100%', src: belvoUri, "data-testid": 'iframeConsentFeedbackBelvoWidget' }));
    }
    if (params.event === OpenFinanceFeedbackEnum.EVENT) {
        return (_jsxs(_Fragment, { children: [loading && _jsx(Loading, {}), _jsx("div", { className: 'white-screen-skeleton', "data-testid": 'containerConsentFeedbackErrorScreen', children: _jsxs("div", { className: 'inner-info', "data-testid": 'containerConsentFeedbackErrorInfo', children: [_jsx("h1", { className: 'title', "data-testid": 'headingConsentFeedbackErrorTitle', children: t('contabilidade-digital.consent-feedback.error-title') }), _jsx("h2", { className: 'desc', "data-testid": 'headingConsentFeedbackErrorDescription', children: t('contabilidade-digital.consent-feedback.error-description') })] }) })] }));
    }
    if (params.event === OpenFinanceFeedbackEnum.SUCCESS) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", { "data-testid": 'containerConsentFeedbackFallback', children: t('contabilidade-digital.consent-feedback.fallback-content') }));
};
const ConsentFeedback = () => {
    const widgetRef = createRef();
    const [belvoUri, setBelvoUri] = useState(null);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const timerState = useTimer({
        initialTime: 5,
        autoStart: false,
        interval: 1000,
    });
    const [prefill] = usePrefillMutation();
    useEffect(() => {
        timerState.reset();
        timerState.pause();
        if (params.event === OpenFinanceFeedbackEnum.APPLICATION_LINK) {
            setBelvoUri(`https://widget.belvo.io/${withBelvoExternalId(location.search)}`);
            setLoading(true);
            return;
        }
        if (params.event === OpenFinanceFeedbackEnum.SUCCESS) {
            setLoading(true);
            const link = searchParams.get('link');
            clearBelvoExternalId();
            prefill({ link: link ?? '' }).then(() => {
                redirectToDashboard();
            });
            return;
        }
        if (params.event === OpenFinanceFeedbackEnum.EXIT) {
            redirectToDashboard();
            return;
        }
        timerState.start();
    }, [location.search, params.event]);
    useEffect(() => {
        if (timerState.isCompleted) {
            setLoading(true);
            redirectToDashboard();
        }
    }, [timerState.isCompleted]);
    return (_jsxs("div", { className: styles.wrapper, "data-testid": 'containerConsentFeedbackWrapper', children: [loading && _jsx(Loading, { size: 'large' }), _jsx(FeedbackContent, { params: params, belvoUri: belvoUri, widgetRef: widgetRef, setLoading: setLoading, loading: loading })] }));
};
export default ConsentFeedback;
